import { toast } from '@/shared/toast'
import { computed, ref, watch, type Ref } from 'vue'

// Project table gets fully rerendered when landing on the page
// This means that the toast will be dismissed and recreated,
// which is why we need to keep track of the toastId to reuse the previous one
let toastId: string | number | null = null

export const useFileUploadProgressToast = (props: { inProgressUploadCount: Ref<number> }) => {
  const total = ref(1)
  const processing = ref(1)
  const message = computed(() => `Uploading ${processing.value}/${total.value} files…`)

  watch(
    () => props.inProgressUploadCount.value,
    (count, oldCount = 0) => {
      // Make a toast when there are no uploads and then there are some
      if (oldCount === 0 && count >= 1) {
        total.value = count
        processing.value = oldCount || 1

        toastId = toast.loading(message, {
          closeButton: true,
          dismissible: true,
          duration: Infinity,
          id: toastId ?? undefined,
        })
        return
      }

      // Dismiss a toast when number of uploads goest to 0
      if (count === 0 && oldCount >= 1) {
        if (toastId !== null) {
          toast.dismiss(toastId)
          toastId = null
        }
        total.value = 1
        processing.value = 1
        return
      }

      total.value = Math.max(total.value, count)
      if (count < oldCount) {
        const diff = oldCount - count
        processing.value += diff
        if (processing.value > total.value) {
          processing.value = total.value
        }
      }
    },
    { immediate: true },
  )
}
